import type { ObjectValues } from "@/src/shared/types/objectValues";

export {
  SCRIPT_PROP_SELECTOR,
  EASY_CUSTOM_ELEMENTS_PREFIX,
  SCRIPT_PROPS_KEY,
  customElementTag,
} from "@/src/shared_modules/custom_elements/constants/customElementNames";

/** Short custom-element names (without prefix). Single source of truth. */
export const DS_CUSTOM_ELEMENT_NAME = {
  Icon: "ds-icon",
  Flag: "ds-flag",
  ContentConnector: "ds-content-connector",
  KeyboardShortcut: "ds-keyboard-shortcut",
  ResizeHandle: "ds-resize-handle",
  Badge: "ds-badge",
  Tag: "ds-tag",
  User: "ds-user",
  PaletteItem: "ds-palette-item",
  Thumbnail: "ds-thumbnail",
  LightBox: "ds-light-box",
  FileItem: "ds-file-item",
  FileUpload: "ds-file-upload",
  Button: "ds-button",
  CopyButton: "ds-copy-button",
  EmojiPicker: "ds-emoji-picker",
  Alert: "ds-alert",
  ProgressBar: "ds-progress-bar",
  Grid: "ds-grid",
  GridItem: "ds-grid-item",
  GridLayout: "ds-grid-layout",
  Page: "ds-page",
  PageHeader: "ds-page-header",
  PageContent: "ds-page-content",
  PageColumns: "ds-page-columns",
  DragHandle: "ds-drag-handle",
  Checkbox: "ds-checkbox",
  Switch: "ds-switch",
  TextField: "ds-text-field",
  TitleField: "ds-title-field",
  PasswordField: "ds-password-field",
  UrlField: "ds-url-field",
  TextInput: "ds-text-input",
  Textarea: "ds-textarea",
  NumberField: "ds-number-field",
  SliderInput: "ds-slider-input",
  RadioGroup: "ds-radio-group",
  OptionList: "ds-option-list",
  Menu: "ds-menu",
  MenuItem: "ds-menu-item",
  Tabs: "ds-tabs",
  Select: "ds-select",
  Datepicker: "ds-datepicker",
  Timepicker: "ds-timepicker",
  Fieldset: "ds-fieldset",
  Form: "ds-form",
  FormLayout: "ds-form-layout",
  ActionButtons: "ds-action-buttons",
  IconPicker: "ds-icon-picker",
  Dialog: "ds-dialog",
  Accordion: "ds-accordion",
  Card: "ds-card",
  Divider: "ds-divider",
  CommentBubble: "ds-comment-bubble",
  Table: "ds-table",
} as const;

export type DSCustomElementName = ObjectValues<typeof DS_CUSTOM_ELEMENT_NAME>;
